<script lang="ts">
    import { smartRounding } from '../components/telematics/tools/smartRounding';

    export let value: number | null = null;
    export let currency: string = 'PLN';
    export let round: number = 2;

    let smartValue =
        value !== null
            ? new smartRounding().getRoundedValues(value, '', { convert_nicer: true })
            : null;
</script>

<div>
    <div class="value">
        {#if value !== null}
            {#if 1 || value < 1000}
                {value.toFixed(round).replace('.', ',')} {currency}
            {:else if smartValue !== null}
                {smartValue.rounded_value} {smartValue.rounded_title} {currency}
            {/if}
        {:else}
            --
        {/if}
    </div>
</div>
